import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import React, { Component } from "react";
import PanToolIcon from "@material-ui/icons/PanTool";
import Header from "./Header";
import { currentUserState } from "../services/session.manager";
import Link from "@material-ui/core/Link";
import AlertDialog from "../components/form-element/AlertDialog";
import { ALERT_DIALOGS } from "../services/form.helper.service";
import { clearCache } from "../services/cache.service";
import { signOut } from "aws-amplify/auth";
import { FormStore } from "../services/form.store";

const styles = (theme) => ({
  root: { height: "100%", paddingTop: 64 },
  shiftContent: {
    minHeight: `calc(100% - 64px)`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
  rootCard: { width: "30%", height: "140px" },
  pantoolIcon: { fontSize: "3.2rem", margin: "5%" },
  initialPoint: { paddingLeft: "8px" },
});

class AccessDenied extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUrl: "",
      userRole: "",
      showLogoutConfirmation: false,
      showAlert: false,
      anchorEl: null,
    };
  }

  componentDidMount() {
    if (currentUserState) {
      this.currentUserSubscription = currentUserState.subscribe((user) => {
        let userRole = user.userRole;
        this.setState({ userRole: userRole });
      });
    }
  }

  componentWillUnmount() {
    this.currentUserSubscription.unsubscribe();
  }

  navLink = (url) => {
    this.setState({
      currentUrl: url,
    });
    const { history } = this.props;
    history.push(url);
  };

  handleLogout = () => {
    this.setState({
      showLogoutConfirmation: true,
    });
  };

  handleConfirmLogout = async () => {
    this.setState({
      showAlert: false,
      showLogoutConfirmation: false,
      anchorEl: null,
    });
    try {
      await signOut({ global: true });
      await clearCache();
      localStorage.clear();
      window.location.href = process.env.REACT_APP_SSO_LOGOUT;
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  handleClose = () => {
    this.setState({
      showAlert: false,
      showLogoutConfirmation: false,
      anchorEl: null,
    });
  };

  handleOk = () => {
    const { history } = this.props;
    history.push(this.state.currentUrl);
    this.setState({
      showAlert: false,
    });
    FormStore.sharedInstance().shouldNavigate(false);
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Header />
        <main className={classes.shiftContent}>
          <Card className={classes.rootCard}>
            <CardContent>
              <Box>
                <Grid container spacing={3}>
                  <Grid item md={2} xs={2}>
                    <Typography>
                      <PanToolIcon className={classes.pantoolIcon} />
                    </Typography>
                  </Grid>
                  <Grid item md={10} xs={10} className={classes.initialPoint}>
                    <Typography gutterBottom variant="h5" component="h2">
                      Access Denied!
                    </Typography>
                    <Typography
                      variant="body1"
                      color="textSecondary"
                      component="p"
                    >
                      {this.props.errorDetail
                        ? `${this.props.errorDetail}`
                        : "You are not allowed to access this screen"}
                    </Typography>
                    {this.state.userRole === "GLOBALADMIN" ? (
                      <Link
                        underline="always"
                        id="createForm"
                        component="button"
                        variant="body2"
                        onClick={() => this.navLink("/createForm")}
                      >
                        New Form
                      </Link>
                    ) : null}
                    {this.state.userRole === "ASSETMANAGER" ? (
                      <Link
                        underline="always"
                        id="assets"
                        component="button"
                        variant="body2"
                        onClick={() => this.navLink("/assets")}
                      >
                        Assets
                      </Link>
                    ) : null}
                    {this.state.userRole === "SITEMANAGER" ||
                    this.state.userRole === "TECHNICIAN" ? (
                      <Link
                        underline="always"
                        id="review"
                        component="button"
                        variant="body2"
                        onClick={() => this.navLink("/review")}
                      >
                        Review
                      </Link>
                    ) : null}
                    {this.state.userRole === "FORMAUTHOR" ||
                    this.props.errorDetail ? (
                      <Link
                        underline="always"
                        id="logout"
                        component="button"
                        variant="body2"
                        onClick={this.handleLogout}
                      >
                        Logout
                      </Link>
                    ) : null}
                  </Grid>
                </Grid>
                {this.state.showLogoutConfirmation ? (
                  <AlertDialog
                    open={this.state.showLogoutConfirmation}
                    onClose={this.handleClose}
                    handleOk={this.handleConfirmLogout}
                    dialogTitle={ALERT_DIALOGS.LOGOUT_TITLE}
                    dialogContent={ALERT_DIALOGS.LOGOUT_CONTENT}
                    cancelButton={ALERT_DIALOGS.LOGOUT_CANCEL}
                    confirmButton={ALERT_DIALOGS.LOGOUT_CONFIRM}
                  />
                ) : null}
              </Box>
            </CardContent>
          </Card>
        </main>
      </div>
    );
  }
}

export default withStyles(styles)(AccessDenied);
